export const ItemTypes = {
    DRAGGABLE: 'Draggable',
};
//# sourceMappingURL=types.js.map